import {extend} from 'flarum/extend';
import IndexPage from 'flarum/components/IndexPage';
import Dropdown from 'flarum/components/Dropdown';
import Button from 'flarum/components/Button';
import DiscussionListState from 'flarum/states/DiscussionListState';

export default function () {
  // Remove sorting options and add a filter button
  extend(IndexPage.prototype, 'viewItems', function (items) {

    if (!app.session.user || !this.currentActiveTag.data.attributes.canApprove) {
      return;
    }

    addFilterButton(this, items);
  });

  function addFilterButton(p, items) {

    const filterMap = function () {
      return {
        nofilter: 'nofilter',
        userview: 'userview',
        noreply: 'noreply'
      };
    }
    const filterOptions = {};
    for (const i in filterMap()) {
      filterOptions[i] = app.translator.trans(`core.forum.index_filter.${i}_button`);
    }
    const selected = app.discussions.filterOption || 'nofilter';

    const buttonOptions = Object.keys(filterOptions).map((value) => {
      const label = filterOptions[value];
      const active = selected === value;

      return Button.component({
        icon: active ? 'fas fa-check' : true,
        onclick: p.filterItems.bind(p, value),
        active: active,
      }, label);
    });

    items.add(
      'filter',
      Dropdown.component({
        buttonClassName: 'Button',
        label: filterOptions[selected],
      }, buttonOptions)
    );
  }

  IndexPage.prototype.filterItems = function (filter) {
    app.discussions.filterOption = filter;
    app.discussions.refresh();
  };

  extend(DiscussionListState.prototype, 'requestParams', function (params) {
    if (!app.session.user) {
      return;
    }

    let q = params.filter.q;
    const filterOption = this.filterOption;

    if (q) {
      switch (filterOption) {
        case 'userview':
          q += ' is:public';
          break;

        case 'noreply':
          q += ' is:unanswered';
          break;
      }

      params.filter.q = q;
    } else {
      switch (filterOption) {
        case 'userview':
          params.filter.public = 'true';
          break;

        case 'noreply':
          params.filter.unanswered = 'true';
          break;
      }
    }
  });
}
